
// import React, { useRef, useState } from 'react';
// import { EditProfileImage } from '../../components/superadmin';
// import { TbTrashX } from "react-icons/tb";
// import { BiCloudUpload } from "react-icons/bi";
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { handleApi } from "../../utils/authentication";
// import { useNavigate } from 'react-router-dom';
// import { toast,ToastContainer } from 'react-toastify';


// const AddClient = () => {
//   const profileImageRef = useRef(null);
//   const [imageUri, setImageUri] = useState('');
//   const [show, setShow] = useState(false);
//   const [file, setFile] = useState(null);
//   const navigate = useNavigate();
//   const [loading,setLoading]=useState(false)

//   const handleImageUpload = (event) => {
//     const file = event.target.files[0];
//     console.log(file, "file upload");
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImageUri(reader.result);
//         setShow(true);
//       };
//       reader.readAsDataURL(file);
//       setFile(file);
//     }
//   };

//   const handleCreateClient = async () => {
//     try {
//       setLoading(true)
//       let method = "POST";
//       let headers = {};
//       let formData = new FormData();
//       if (imageUri) {
//         let response = await fetch(imageUri);
//         let image_file = await response.blob();
//         formData.append('client_logo', image_file, file?.name);
//       }
//       formData.append('client_name', formik.values.client_name);
//       formData.append('first_name', formik.values.first_name);
//       formData.append('last_name', formik.values.last_name);
//       formData.append('email', formik.values.email);
//       formData.append('user_setup_password_link_prefix', 'http://localhost:3000/client/setup_password/');
//       formData.append('website', 'http://localhost:8000/auth/user-setup-password/');

//       let result = await handleApi('create_client', method, headers, formData);
//       if (result?.success) {
//         toast.success('Account Created Successfully.', {
//           position: "top-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "light",

//           });

//         navigate('/super_admin/clients');
//       }else{
//         toast.error(result?.error?.error_message, {
//           position: "top-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "light",

//           });


//       }
//       setTimeout(()=>{

//       },1000)

//     } catch (e) {

//       console.log(e);
//       toast.error(e.message, {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "light",

//         });
//     } finally{
//       setLoading(false)

//     }
//   };

//   const validationSchema = Yup.object({
//     client_name: Yup.string().required('Client Name is Required'),
//     first_name: Yup.string().required('Firstname is Required'),
//     last_name: Yup.string().required('Lastname is Required'),
//     email: Yup.string().email('Invalid email address').required('Email is Required'),
//   });

//   const formik = useFormik({
//     initialValues: {
//       client_name: '',
//       first_name: '',
//       last_name: '',
//       email: '',
//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {

//      handleCreateClient();


//     },
//   });

//   return (
//     <form onSubmit={formik.handleSubmit}>

//       <div className='w-100 h-100 position-relative d-flex flex-column align-items-center mb-2 '>
//         <EditProfileImage show={show} setShow={setShow} uri={imageUri} setImageUri={setImageUri} />
//         <div className='card profile_card px-3 my-2 '>
//           <div>
//             <h5 className='pb-0'> Client Info  </h5>
//           </div>
//           {/* profile image */}
//           <div className='row border-1 border-bottom pb-4'>
//             <div className='col-xl-2 d-flex justify-content-center justify-content-xl-start  '>
//               <img
//                 src={imageUri ? imageUri : "https://cdn3.iconfinder.com/data/icons/business-round-flat-vol-1-1/36/user_account_profile_avatar_person_student_male-512.png"}
//                 alt="Profile"
//               />
//               <input
//                 ref={profileImageRef}
//                 type="file"
//                 id="profile_image"
//                 className='d-none'
//                 accept="image/*"
//                 onChange={handleImageUpload}
//               />
//             </div>
//             <div className='col-xl-6 row d-flex align-items-end'>
//               <div className='col-12 col-md-12 col-lg-6 mb-2'>
//                 <button type="button" className='w-100 btn btn-outline-custom btn-outline-primary rounded-pill d-flex justify-content-center align-items-center gap-1'><TbTrashX /> Delete Logo</button>
//               </div>
//               <div className='col-12 col-md-12 col-lg-6 mb-2'>
//                 <button type="button" onClick={() => {
//                   profileImageRef.current.click();
//                 }} className='w-100 py-2 btn btn-primary rounded-pill d-flex justify-content-center align-items-center'><BiCloudUpload /> Upload New Logo</button>
//               </div>
//             </div>
//           </div>
//           <div className="mb-1 row">
//             <label htmlFor="client_name" className="col-lg-3 col-form-label">Client Name</label>
//             <div className="col-lg-6">
//               <input type="text"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.client_name}
//                 className="form-control"
//                 id="client_name"
//                 placeholder='Enter Client Name' />
//               {formik.touched.client_name && formik.errors.client_name ? (
//                 <div className='text-danger text-start small'>{formik.errors.client_name}</div>
//               ) : null}
//             </div>
//           </div>
//           <div className="mb-1 row">
//             <label htmlFor="first_name" className="col-lg-3 col-form-label">Firstname</label>
//             <div className="col-lg-6">
//               <input type="text"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.first_name}
//                 className="form-control"
//                 id="first_name"
//                 placeholder='Enter Firstname' />
//               {formik.touched.first_name && formik.errors.first_name ? (
//                 <div className='text-danger text-start small'>{formik.errors.first_name}</div>
//               ) : null}
//             </div>
//           </div>
//           <div className="mb-1 row">
//             <label htmlFor="last_name" className="col-lg-3 col-form-label">Lastname</label>
//             <div className="col-lg-6">
//               <input type="text"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.last_name}
//                 className="form-control"
//                 id="last_name"
//                 placeholder='Enter Lastname' />
//               {formik.touched.last_name && formik.errors.last_name ? (
//                 <div className='text-danger text-start small'>{formik.errors.last_name}</div>
//               ) : null}
//             </div>
//           </div>
//           <div className="mb-1 row">
//             <label htmlFor="email" className="col-lg-3 col-form-label">Email</label>
//             <div className="col-lg-6">
//               <input type="text"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.email}
//                 className="form-control"
//                 id="email"
//                 placeholder='Enter Email' />
//               {formik.touched.email && formik.errors.email ? (
//                 <div className='text-danger text-start small'>{formik.errors.email}</div>
//               ) : null}
//             </div>
//           </div>
//           <div className="mb-1 row mt-2">
//             <div>
//               <button type='submit' className='btn btn-primary rounded-pill px-5'>Save</button>
//             </div>
//           </div>
//         </div>
//         <div className='card profile_card px-3 my-2 d-none'>
//           <div>
//             <h5 className='pb-0'>Admin Info</h5>
//           </div>
//           <div className="mb-1 row">
//             <label htmlFor="admin_fullname" className="col-lg-3 col-form-label">Fullname</label>
//             <div className="col-lg-6">
//               <input type="text" className="form-control" id="admin_fullname" placeholder='Fullname' />
//             </div>
//           </div>
//           <div className="mb-1 row">
//             <label htmlFor="admin_email" className="col-lg-3 col-form-label">Email</label>
//             <div className="col-lg-6">
//               <input type="email" className="form-control" id="admin_email" placeholder='Email' />
//             </div>
//           </div>
//           <div className="mb-1 row mt-2">
//             <div>

//               {loading?
//               <button type='button'  className='btn btn-primary rounded-pill px-5' disabled>Saving...</button> :
//               <button type='submit'  className='btn btn-primary rounded-pill px-5'>Save</button>}

//             </div>
//           </div>
//         </div>
//       </div>
//     </form>
//   );
// };

// export default AddClient;

import React, { useRef, useState } from 'react';
import { EditProfileImage } from '../../components/superadmin';
import { TbTrashX } from "react-icons/tb";
import { BiCloudUpload } from "react-icons/bi";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { handleApi } from "../../utils/authentication";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import user_default from "../../assests/user_default.png"
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import { getdateOneYearFromDate } from "../../utils/date_format"
import Select from "react-select"
import { customStyles } from '../../utils/select_style';
import { ConfirmModal } from '../../components/ConfirmModal';

const AddClient = () => {
  const profileImageRef = useRef(null);
  const [imageUri, setImageUri] = useState('');
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showModal,setShowModal]=useState(false)

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUri(reader.result);
        setShow(true);
      };
      reader.readAsDataURL(file);
      setFile(file);
    }
    event.target.value = ''
  };

  const handleCreateClient = async () => {
    try {
      setLoading(true)  // Start loading
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      if (imageUri) {
        let response = await fetch(imageUri);
        let image_file = await response?.blob();
        formData.append('client_logo', image_file, file?.name);
      } 
      
      // else {
      //   toast.error("Please Upload Logo", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "light",
      //   })
      //   return

      // }
      formData.append('client_name', formik.values.client_name);
      formData.append('first_name', formik.values.first_name);
      formData.append('last_name', formik.values.last_name);
      formData.append('email', formik.values.email);
      formData.append('user_setup_password_link_prefix', process.env.REACT_APP_URL + 'client/setup_password/');
      formData.append('website', formik.values.website);
      formData.append('subscription_start_date', format(new Date(formik?.values?.subscription_start_date), 'yyyy-MM-dd'));
      formData.append('subscription_end_date', format(new Date(formik?.values?.subscription_end_date), 'yyyy-MM-dd'));
      formData.append('total_members', formik.values.total_members);
      formData.append('subscription_value', formik.values.subscription_value);
      formData.append('is_blocked', formik.values.is_blocked?.value);
      if (formik.values.is_agency === "yes") {
        formData.append('is_agency', 1)
      } else {
        formData.append('is_agency', 0)

      }
    

      let result = await handleApi('create_client', method, headers, formData);


      if (result?.success) {
        toast.success('Account Created Successfully.', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
          setShowModal(false)
          navigate('/super_admin/clients');



      } else {
        toast.error(result?.error?.error_message?result?.error?.error_message:"Something went wrong! Please Try again later", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
      }
    } catch (e) {
      toast.error(e.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    } finally {
      setLoading(false)  // Stop loading
      setShowModal(false)
    }
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const validationSchema = Yup.object({
    client_name: Yup.string().required('Client Name is Required'),
    first_name: Yup.string().required('Firstname is Required').matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
    last_name: Yup.string().required('Lastname is Required').matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
    email: Yup.string().email('Invalid email address').required('Email is Required'),
    subscription_start_date: Yup.date().required('Start subscription date is required'),
    subscription_end_date: Yup.date()
      .required('End Subscription date is required')
      .nullable()
      .min(Yup.ref('subscription_start_date'), 'End Subscription date must be grater than start subscription date')
      .min(new Date(), 'End date cannot be in the past'),
    total_members: Yup.number().required('Total Members is Required').moreThan(0, 'Number must be greater than 0'),
    subscription_value: Yup.number().required("Subscription Value is required").moreThan(0, 'Number must be greater than 0'),
    is_blocked: Yup.object({ label: Yup.string().required(), value: Yup.number().required().min(0).max(1) })

  });

  const formik = useFormik({
    initialValues: {
      client_name: '',
      first_name: '',
      last_name: '',
      email: '',
      website: '',
      subscription_start_date: new Date(),
      subscription_end_date: getdateOneYearFromDate(format(new Date(), 'yyyy-MM-dd')),
      total_members: 1,
      is_agency: "no",
      is_blocked: { label: 'Active', value: 0 }
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // console.log(values)
      // handleCreateClient();
      setShowModal(true)
    },
  });

  return (
    <div>

      <form onSubmit={formik.handleSubmit}>

        <div className='w-100 h-100 position-relative d-flex flex-column align-items-center mb-2 '>
          <EditProfileImage show={show} setShow={setShow} uri={imageUri} setImageUri={setImageUri} />
          <div className='card profile_card '>
            <div>
              <h5 className='pb-0'> Client Info  </h5>
            </div>
            <div className='row border-1 border-bottom pb-4'>
              <div className='col-xl-2 d-flex justify-content-center justify-content-xl-start  '>
                <img
                  src={imageUri ? imageUri : user_default}
                  alt="Profile"
                  style={{
                    width: 'auto',
                    height: '64px',
                    borderRadius: '0%'

                  }}
                />
                <input
                  ref={profileImageRef}
                  type="file"
                  id="profile_image"
                  className='d-none'
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </div>
              <div className='col-xl-6 row d-flex align-items-end'>
                <div className='col-12 col-md-12 col-lg-6 mb-2'>
                  <button type="button"
                    onClick={() => {
                      setImageUri('')
                    }}
                    className={`w-100 ${!imageUri && "disable_btn"}  btn btn-outline-custom btn-outline-primary rounded-pill d-flex justify-content-center align-items-center gap-1`}
                    disabled={!imageUri}
                  ><TbTrashX /> Delete Logo</button>
                </div>
                <div className='col-12 col-md-12 col-lg-6 mb-2'>
                  <button type="button" onClick={() => {
                    profileImageRef.current.click();
                  }} className='w-100 py-2 btn btn-primary rounded-pill d-flex justify-content-center align-items-center gap-1'><BiCloudUpload /> Upload New Logo</button>
                </div>
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="client_name" className="col-lg-3 col-form-label">Client Name (University/Organization Name)*</label>
              <div className="col-lg-6">
                <input type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.client_name}
                  className="form-control"
                  id="client_name"
                  placeholder='Enter Client Name' />
                {formik.touched.client_name && formik.errors.client_name ? (
                  <div className='text-danger text-start small'>{formik.errors.client_name}</div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="first_name" className="col-lg-3 col-form-label"> Client Admin First Name*</label>
              <div className="col-lg-6">
                <input type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.first_name}
                  className="form-control"
                  id="first_name"
                  placeholder='Enter Firstname' />
                {formik.touched.first_name && formik.errors.first_name ? (
                  <div className='text-danger text-start small'>{formik.errors.first_name}</div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="last_name" className="col-lg-3 col-form-label"> Client Admin Last Name*</label>
              <div className="col-lg-6">
                <input type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.last_name}
                  className="form-control"
                  id="last_name"
                  placeholder='Enter Lastname' />
                {formik.touched.last_name && formik.errors.last_name ? (
                  <div className='text-danger text-start small'>{formik.errors.last_name}</div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="email" className="col-lg-3 col-form-label">Admin Email*</label>
              <div className="col-lg-6">
                <input type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  className="form-control"
                  id="email"
                  placeholder='Enter Email' />
                {formik.touched.email && formik.errors.email ? (
                  <div className='text-danger text-start small'>{formik.errors.email}</div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="website" className="col-lg-3 col-form-label">Website Name</label>
              <div className="col-lg-6">
                <input type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.website}
                  className="form-control"
                  id="website"
                  placeholder='Enter Client Name' />
                {formik.touched.client_name && formik.errors.website ? (
                  <div className='text-danger text-start small'>{formik.errors.website}</div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="website" className="col-lg-3 col-form-label">Subscription Start Date*</label>
              <div className="col-lg-6">
                <DatePicker
                  showIcon={false}
                  selected={formik.values.subscription_start_date}
                  // minDate={}
                  onChange={(date) => {
                    formik.setFieldValue('subscription_start_date', date)
                    date && formik.setFieldValue('subscription_end_date', getdateOneYearFromDate(format(date, 'yyyy-MM-dd')))
                  }}
                  dateFormat="MM/dd/yyyy"
                  placeholderText="Select Start Date"
                  className='form-control'


                />
                {formik.touched.subscription_start_date && formik.errors.subscription_start_date ? (
                  <div className='text-danger text-start small'>{formik.errors.subscription_start_date}</div>
                ) : null}

              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="website" className="col-lg-3 col-form-label">Subscription Expiration Date*</label>
              <div className="col-lg-6">
                <DatePicker
                  showIcon={false}
                  selected={formik.values.subscription_end_date}
                  minDate={formik.values.subscription_start_date}
                  onChange={(date) => {

                    formik.setFieldValue('subscription_end_date', date)

                  }}
                  dateFormat="MM/dd/yyyy"
                  placeholderText="Select Subscription Expiration Date"
                  className='form-control'


                />
                {formik.touched.subscription_end_date && formik.errors.subscription_end_date ? (
                  <div className='text-danger text-start small'>{formik.errors.subscription_end_date}</div>
                ) : null}

              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="subscription_value" className="col-lg-3 col-form-label">Subscription Value ( In $ )*</label>
              <div className="col-lg-6 ">
                <input type="number"
                  className="form-control"
                  id="subscription_value"
                  min={0}
                  placeholder='Subscription Value'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.subscription_value}

                />
                {formik.touched.subscription_value && formik.errors.subscription_value ? (
                  <div className='text-danger text-start small'>{formik.errors.subscription_value}</div>
                ) : null}
              </div>


            </div>
            <div className="mb-1 row">
              <label htmlFor="total_members" className="col-lg-3 col-form-label">Member Count (Including Client Admin)*</label>
              <div className="col-lg-6">
                <input type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.total_members}
                  className="form-control"
                  id="total_members"
                  placeholder='Enter Members Count' />
                {formik.touched.total_members && formik.errors.total_members ? (
                  <div className='text-danger text-start small'>{formik.errors.total_members}</div>
                ) : null}
              </div>
            </div>

            <div className="mb-1 row">
              <label htmlFor="total_members" className="col-lg-3 col-form-label">Is Agency</label>
              <div className="col-lg-6">
                <div className='d-flex gap-3 align-items-center'>
                  <div className='d-flex gap-3 align-items-center'>
                    <input type="radio" name="is_agency" id="is_agency_yes"
                      value="yes"
                      checked={formik.values.is_agency === 'yes'}
                      onChange={formik.handleChange}
                    />
                    <label htmlFor="is_agency_yes">Yes</label>

                  </div>
                  <div className='d-flex gap-3 align-items-center'>
                    <input type="radio" name="is_agency" id="is_agency_no"
                      value="no"
                      checked={formik.values.is_agency === 'no'}
                      onChange={formik.handleChange}
                    />
                    <label htmlFor="is_agency_no">No</label>

                  </div>
                </div>

              </div>
            </div>

            <div className="mb-1 row ">
              <label htmlFor="role" className="col-lg-3 col-form-label">Client Status*</label>
              <div className="col-lg-6">

                <Select
                  id="is_blocked"
                  name="is_blocked"
                  placeholder="Select Status"
                  styles={customStyles}
                  value={formik.values.is_blocked}
                  options={[{ label: "Active", value: 0 }, { label: "Block", value: 1 }]}
                  onChange={(selected_options) => {

                    formik.setFieldValue('is_blocked', selected_options)

                  }}


                />
                {formik.touched.is_blocked && formik.errors.is_blocked ? (
                  <div className='text-danger text-start small'>{formik.errors.is_blocked}</div>
                ) : null}
              </div>
            </div>



            <div className="mb-1 row mt-2  row">
              <div className='col-lg-9 d-flex justify-content-end'>
                {loading
                  ? <button type='button' className='btn btn-primary rounded-pill px-5' disabled>Creating...</button>
                  : <button type='submit' className='btn btn-primary rounded-pill px-5'>Create</button>}
              </div>
            </div>
          </div>
        </div>
      </form>
          <ConfirmModal
            show={showModal}
            loadingOnsubmit={loading}
            onClose={() => setShowModal(false)}
            onSubmit={handleCreateClient}
            title={"Confirm Client Creation"}
            body={"Would you like to continue creating this client?"}
          />
    </div>
    
  );
}

export default AddClient;

